const Reviews = (function(window, $) {

    function Reviews(target) {
        this.$element = $(target);
        this.$form = this.$element.find('form');
        this.$forminput = this.$element.find('form input');
        this.$success = this.$element.find('.review-success').hide();
        this.$error = this.$element.find('.review-error').hide();

        this.addEvents();
    }

    Reviews.prototype.addEvents = function() {
        this.$form.on('submit', this.submit.bind(this));
        this.$forminput.on('focusin', this.modifyState.bind(this));
    };

    Reviews.prototype.submit = function(e) {

        e.preventDefault();

        this.$success.hide();
        this.$error.hide();

        $.ajax(window.ajaxURL, {
            type: 'POST',
            data: this.$form.serialize()
        }).done(function (data) {
            this.$success.show();
            // this.$form.hide();
            this.$form.fadeOut('fast');
        }.bind(this)).fail(function (data) {
            let form = this.$form;
            // this.$error.show();
            form.fadeIn('fast');
            form.addClass('invalid');

            //Reset inputs
            form.find('.is-invalid').removeClass('is-invalid');
            form.find('.invalid-feedback').remove();

            $.each(data.responseJSON.data.errors, function(field_name, error) {
                form.find('[name='+field_name+']').first().parent().addClass('is-invalid').append(
                    "<div class='invalid-feedback'>"+error+"</div>"
                );
            });
        }.bind(this));
    };

    Reviews.prototype.modifyState = function() {
        this.$form.removeClass('invalid');
        this.$error.hide();
    }

    return Reviews;

}(window, jQuery));

export {Reviews};
